<script>
  export default {
    data () {
      return {
        that: this,
        user: {},
      }
    },
    filters: {
      // 将日期过滤为 hour:minutes
      time (date) {
        if (typeof date === 'string') {
          date = new Date(date)
        }
        return date.get + ':' + date.getHours() + ':' + date.getMinutes()
      },

    },
    directives: {
      // 发送消息后滚动到底部
      bottom: {
        inserted: function (el) {

          setTimeout(function () {
            el.scrollTop = el.scrollHeight - el.clientHeight
          }, 100)
        },
        update: function (el) {

          setTimeout(function () {
            el.scrollTop = el.scrollHeight - el.clientHeight
          }, 100)
        }
      }
    },
    computed: {
      session () {
        return this.$store.getters['session']
      },
      getSender (id, platformId) {
        return function (id, platformId) {
          switch (id) {
            case 1:
              return this.getPlatform(platformId) //平台系统
            case 2:
              return this.getPlatform(platformId) //平台客服
            case 3:
              return '发' //平台商家
            case 4:
              return '接' //平台打手
            default:
              return '代' //暂未定义
          }
        }
      },
    },
    methods: {
      getPlatform (id) {
        switch (id) {
          case 1:
            return '通' //代练通
          case 4:
            return '妈' //代练妈妈
          case 16:
            return '内' //内群
          default:
            return '代' //暂未定义
        }
      },
      onCopy (e) {
        this.$message('内容已复制到剪切板！')
      },
      // 复制失败时的回调函数
      onError (e) {
        this.$message('抱歉，您的浏览器不支持！')
      },
    }
  }
</script>

<template>
  <div class="message" v-if="session">
    <div class="title">
      {{session.id}}
      <span>
         <el-button style="margin-left: 15px;" type="text" v-clipboard:copy="session.id" v-clipboard:success="onCopy"
                    v-clipboard:error="onError" v-if="session.id!=null">复制</el-button>
      </span>
    </div>
    <ul v-bottom="session.messages">
      <li v-for="item in session.messages">
        <p class="time">
          <span>{{ item.SendTime }}</span>
        </p>
        <div class="main" :class="{ self: (item.SenderSource==3) }">
          <div class="avatar">
            <span class="avatar-content">
              {{getSender(item.SenderSource,item.PlatformId)}}
            </span>
          </div>
          <div class="text">{{ item.Content }}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="less" scoped>
  .message {

    ul {
      list-style: none;
      padding-left: 10px;
      overflow-y: scroll;
      height: 80%;
      margin-top: 0px;
    }

    ::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px #dcdcdc;
      border-radius: 10px;
      background-color: #F5F5F5;
    }

    ::-webkit-scrollbar-thumb {
      -webkit-box-shadow: inset 0 0 6px #dcdcdc;
      border-radius: 10px;
      background-color: #F5F5F5;
    }

    ::-webkit-scrollbar {
      width: 12px;
    }

    li {
      margin-bottom: 15px;
    }

    .time {
      margin: 7px 0;
      text-align: center;

      > span {
        display: inline-block;
        padding: 0 18px;
        font-size: 12px;
        color: #fff;
        border-radius: 2px;
        background-color: #dcdcdc;
      }
    }

    .title {
      padding: 0px;
      text-align: center;
      font-size: 12px;
      font-weight: 500;
      height: 60px;
      line-height: 60px;
      background: rgb(233, 233, 233);
      width: 100%;
      /*********重点在这里，**************/
      /*Internet Explorer, Edge 15 及更早 IE 版本不支持 sticky 定位。 Safari 需要使用 -webkit- prefix*/
      position: -webkit-sticky; /* Safari */
      position: sticky;
      top: 0;
      z-index: 999;
    }

    .avatar {
      float: left;
      margin: 0 10px 0 0;
      border-radius: 3px;
      background-color: rgb(89, 150, 251);
      color: rgb(248, 248, 248);
      width: 40px;
      height: 40px;
      font-size: 18px;
      text-align: center;
      display: inline-block;
    }

    .avatar-content {
      margin-top: 20%;
      display: block;
    }

    .text {
      display: inline-block;
      position: relative;
      padding: 0 10px;
      max-width: ~'calc(80%)';
      min-height: 30px;
      line-height: 2.5;
      font-size: 12px;
      text-align: left;
      word-break: break-all;
      background-color: #fafafa;
      border-radius: 4px;

      &:before {
        content: " ";
        position: absolute;
        top: 9px;
        right: 100%;
        border: 6px solid transparent;
        border-right-color: #fafafa;
      }
    }

    .self {
      text-align: right;
      margin-right: 10px;

      .avatar {
        float: right;
        margin: 0 0 0 10px;
      }

      .text {
        background-color: #b2e281;

        &:before {
          right: inherit;
          left: 100%;
          border-right-color: transparent;
          border-left-color: #b2e281;
        }
      }
    }
  }
</style>
